import React from "react";
import "./Requirements.css";
import { Trans, useTranslation } from "react-i18next";
const DayAndRoseRequirements = () => {
  const { t } = useTranslation("settings");
  return (
    <div className="cuscarrier__reqrmnts_box">
      <Trans
        t={t}
        i18nKey="carriers.custom.requirements.dayRoss"
        components={{
          mail: (
            <a href={`mailto:mydayross@dayandrossinc.ca`} className="email_space">
              mydayross@dayandrossinc.ca
            </a>
          ),
        }}
      />
    </div>
  );
};

export default DayAndRoseRequirements;
